import React, { useContext } from 'react';
import { CreativeListContext } from '../../contexts/creativeListContext';
import { History } from 'history';

interface SearchItemProps {
  hit: any;
  components: any;
  pathname: string;
  searchQuery?: string;
  history?: History;
}

export default function SearchItem({
  hit,
  components,
  pathname,
  searchQuery,
  history
}: SearchItemProps) {
  const isCreativePage = window.location.pathname.includes('/creative');
  const { setSelectedUserId } = useContext(CreativeListContext);

  const handleClick = (e: any) => {
    if (!isCreativePage || pathname !== 'user') return;

    e.preventDefault();

    if (searchQuery && history) {
      history.replace(`/creatives?q=${encodeURIComponent(searchQuery)}`);
    } else {
      setSelectedUserId(hit.id);
    }
  };

  return (
    <a
      href={`/${pathname}/${hit.id}`}
      target="_blank"
      rel="noreferrer"
      className="aa-ItemLink"
      onClick={handleClick}
    >
      <div className="aa-ItemWrapper">
        <div className="aa-ItemContent">
          {hit.avatar && (
            <div className="aa-ItemIcon">
              <img
                src={hit.avatar}
                alt={`${pathname === 'project' ? hit.title : hit.name}`}
                width="40"
                height="40"
              />
            </div>
          )}
          <div className="aa-ItemContentBody">
            <div className="aa-ItemContentTitle">
              <components.Highlight
                hit={hit}
                highlightedTagName="mark"
                attribute={`${pathname === 'project' ? 'title' : 'name'}`}
              />
            </div>
            {pathname === 'user' && (
              <div className="aa-ItemContentDescription">
                <components.Highlight
                  hit={hit}
                  attribute="professionsCombined"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </a>
  );
}
